import { Outlet } from 'react-router-dom';

import { ReloadPrompt } from '@/reloadPrompt';

const Root = () => {
  return (
    <>
      <Outlet />
      <ReloadPrompt />
    </>
  );
};

export default Root;
